import React from "react";

function CheckIcon() {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <polygon style={{fill: '#3db078'}} points="31 290.8 200.6 443.5 266.6 370.2 97 217.5 31 290.8"/>
      <polygon style={{fill: '#3db078'}} points="404.6 67.8 127 377.5 200.4 443.3 478 133.6 404.6 67.8"/>
    </svg>
  );
}

export default CheckIcon;
